import Vue from 'vue';

Vue.filter('commaOnCurrency', value => {
    return (value).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
});